import Icon from '../components/Icon.vue'

Icon.register({
  ship: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M496.6 372.6c17.8 44.4 58.6 75.4 119.4 75.4 13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24-61 0-107.5-20.6-143.3-59.4-14.4 34.8-48.8 59.4-88.7 59.4h-128c-40 0-74.3-24.6-88.7-59.4-35.8 38.8-82.2 59.4-143.3 59.4-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24 61.6 0 101.8-31.7 119.4-75.4l-70-70c-16.9-16.9-9.9-45.8 12.8-53.1l41.8-13.4v-140.1c0-17.7 14.3-32 32-32h64v-40c0-13.3 10.7-24 24-24h144c13.3 0 24 10.7 24 24v40h64c17.7 0 32 14.3 32 32v140.1l41.8 13.4c22.8 7.3 29.7 36.2 12.8 53.1zM192 128v87.5l118.2-38c2.6-0.8 7-1.5 9.8-1.5s7.2 0.7 9.8 1.5l118.2 38v-87.5h-256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ship.js
// module id = 1881
// module chunks = 0